<template>
  <div class="row">
    <div v-if="itemCount > 0" class="col-12 col-lg-12">
      <div ref="carouselContainer" class="mw-carousel-auto list-item-carousel owl-carousel owl-theme">
        <slot-component v-for="(item, index) in $slots.items" :key="index" :vnode="item"/>
      </div>
    </div>
    <div v-for="item in $slots.items" v-else :class="columnWidths">
      <slot-component :vnode="item" />
    </div>
  </div>
</template>

<script>

// import "owl.carousel";

export default {
  components:
    {
      SlotComponent:
            {
              functional: true,
              render: (createElement, context) => context.data.attrs.vnode
            }
    },

  props: {
    itemsPerPage:
            {
              type: Number,
              default: 4
            },
    displayDots: {
      type: Boolean,
      default: true
    },
    displayNav: {
      type: Boolean,
      default: true
    },
    isLoop: {
      type: Boolean,
      default: true
    },
    enableLazy: {
      type: Boolean,
      default: false
    },
    marginValue: {
      type: Number,
      default: 30
    },
    paddingS: {
      type: Number,
      default: 30
    },
    autoPlayEnable: {
      type: Boolean,
      default: false
    },
    autoPlayTimeout: {
      type: Number,
      default: 5000
    },
    autoPlayHover: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      itemCount: 0
    }
  },

  computed:
    {
      columnWidths () {
        const itemsPerPage = Math.min(Math.max(this.itemsPerPage, 1), 4)

        return [
          'col-12',
          itemsPerPage === 1 ? 'col-sm-12' : 'col-sm-6',
          'col-md-' + (12 / itemsPerPage)
        ]
      }
    },

  created () {
    if (this.$slots.items) {
      this.itemCount = this.$slots.items.length
    }
  },

  mounted () {
    this.$nextTick(() => {
      this.initializeCarousel()
    })
  },

  methods:
    {
      initializeCarousel () {
        $(this.$refs.carouselContainer).owlCarousel({
          autoHeight: true,
          dots: this.displayDots,
          items: this.itemsPerPage,
          responsive: {
            0: { items: 1 },
            576: { items: this.itemsPerPage > 1 ? 2 : 1 },
            768: { items: this.itemsPerPage > 3 ? 3 : this.itemsPerPage },
            992: { items: this.itemsPerPage }
          },
          lazyLoad: this.enableLazy,
          loop: this.isLoop,
          margin: this.marginValue,
          autoplay: this.autoPlayEnable,
          autoplayTimeout: this.autoPlayTimeout,
          autoplayHoverPause: this.autoPlayHover,
          stagePadding: this.paddingS,
          mouseDrag: true,
          nav: this.displayNav,
          navClass: [
            'owl-single-item-nav left carousel-control list-control-special',
            'owl-single-item-nav right carousel-control list-control-special'
          ],
          navContainerClass: '',
          navText: [
            '<i class="owl-single-item-control fa fa-chevron-left" aria-hidden="true"></i>',
            '<i class="owl-single-item-control fa fa-chevron-right" aria-hidden="true"></i>'
          ],
          smartSpeed: 350
        })
      }
    }
}
</script>
